/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContainerMaskResponse } from './container-mask-response';


export interface ContainerMaskResponsePagedList { 
    totalCount?: number;
    items?: Array<ContainerMaskResponse> | null;
}

